import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=005c5761&scoped=true&"
import script from "./BottomNav.vue?vue&type=script&lang=js&"
export * from "./BottomNav.vue?vue&type=script&lang=js&"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=005c5761&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c5761",
  null
  
)

export default component.exports